import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20university%20campus%20in%20spring%20season%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20historic%20red%20brick%20buildings%2C%20green%20lawn%2C%20students%20walking%20on%20path%2C%20warm%20golden%20sunlight%2C%20dreamy%20atmospheric%20mood%2C%20soft%20pastel%20colors%2C%20vibrant%20yet%20peaceful%2C%20clean%20artistic%20composition%2C%20spring%20blossoms%20scattered%20in%20gentle%20breeze&width=1920&height=1080&seq=hero-main-01&orientation=landscape"
        alt="校园春色 - 春日樱花盛开的校园美景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-6">
        <p className="text-accent-300 text-sm md:text-base font-medium tracking-widest mb-4 animate-[fadeInUp_0.8s_ease-out]">
          CAMPUS SPRING
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-[fadeInUp_0.8s_ease-out_0.1s_backwards]">
          校园春色
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8 animate-[fadeInUp_0.8s_ease-out_0.2s_backwards]">
          记录青春校园里最美好的四季风光与青春故事。
          从春日樱花盛开到秋叶飘落，感受校园生活的纯真与美好。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.3s_backwards]">
          <Link
            to="/category/scenery"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all duration-300"
          >
            探索校园风光
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/40 hover:border-white/80 text-white hover:text-white rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all duration-300"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-16 animate-[fadeInUp_0.8s_ease-out_0.4s_backwards]">
          <div className="w-6 h-10 border-2 border-white/40 rounded-full mx-auto flex items-start justify-center">
            <div className="w-1.5 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}